import client from '@/utils/httpClient';
import { useMutation, useQueryClient } from 'react-query';
import { ConferenceUserAssignemtKeys } from './conferenceUserAssignment.keys';

export interface ConferenceUserAssignmentDto {
  id: string;
  userId: string;
  conferenceId: string;
}

interface AddConferenceUserAssignment {
  userId: string;
  conferenceId: string;
}

async function createConferenceUserAssignment(
  data: AddConferenceUserAssignment,
): Promise<ConferenceUserAssignmentDto> {
  return client
    .post<ConferenceUserAssignmentDto>('/conferenceuserassignments', data)
    .then((response) => response.data);
}

export function useCreateConferenceUserAssignment() {
  const client = useQueryClient();

  return useMutation((data: AddConferenceUserAssignment) => createConferenceUserAssignment(data), {
    onSuccess: () => {
      client.invalidateQueries(ConferenceUserAssignemtKeys.list());
    },
  });
}
